import React from 'react';
import { X, Check, Crown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Comparacion() {
  const sinPack = ['Solo tenés el material técnico base', 'Sin guía para elegir tu equipamiento', 'Sin herramientas para controlar tus emociones en partido', 'Te quedás sin contenido al terminar los 30 días'];
  const conPack = ['Guía de equipamiento para comprar con criterio y sin errores', 'Técnicas de mentalidad para mantener la calma en los momentos clave', 'Plan de 60 días para seguir progresando después del pack base'];
  return <section className="py-16 bg-court-gradient relative border-t border-white/5" data-id="element-37">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-38">
        <FadeIn data-id="element-39">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center uppercase mb-3" data-id="element-40">
            Qué vas a obtener con el{' '}
            <span className="text-neon" data-id="element-41">Pack Pro Élite</span>
          </h2>
          <p className="text-center text-gray-400 max-w-xl mx-auto mb-10" data-id="element-42">
            La diferencia entre tener el pack base y tener el sistema completo
            de alto rendimiento
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-43">
          {/* Sin Pack Pro Élite */}
          <FadeIn direction="right" data-id="element-44">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 h-full" data-id="element-45">
              <span className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 text-gray-300 text-xs font-bold uppercase tracking-wide px-3 py-1.5 rounded-full mb-4" data-id="element-46">
                <X className="w-4 h-4" data-id="element-47" /> Si no tenés Pack Pro Élite
              </span>
              <h3 className="font-display text-xl font-bold text-gray-200 mb-5" data-id="element-48">
                Solo el pack base
              </h3>
              <ul className="space-y-4" data-id="element-49">
                {sinPack.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-400 text-sm" data-id="element-50">
                    <X className="w-5 h-5 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-51" />
                    <span data-id="element-52">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Con Pack Pro Élite */}
          <FadeIn direction="left" delay={0.15} data-id="element-53">
            <div className="relative bg-padel-blue border-2 border-neon rounded-2xl p-6 h-full shadow-[0_0_30px_rgba(198,255,0,0.12)] overflow-hidden" data-id="element-54">
              <div className="absolute top-0 right-0 w-48 h-48 bg-neon/10 blur-[80px] rounded-full pointer-events-none" data-id="element-55"></div>

              {/* Recommended badge */}
              <div className="flex justify-center -mt-10 mb-4 relative z-10" data-id="element-56">
                <span className="inline-flex items-center gap-1.5 bg-neon text-black text-xs font-bold uppercase tracking-wide px-4 py-1.5 rounded-full shadow-[0_0_15px_rgba(198,255,0,0.5)]" data-id="element-57">
                  <Crown className="w-4 h-4" data-id="element-58" /> Recomendado
                </span>
              </div>

              <span className="inline-flex items-center gap-1.5 bg-neon/10 border border-neon/30 text-neon text-xs font-bold uppercase tracking-wide px-3 py-1.5 rounded-full mb-4 relative z-10" data-id="element-59">
                <Check className="w-4 h-4" data-id="element-60" /> Si tenés el Pack Pro Élite
              </span>
              <h3 className="font-display text-xl font-bold text-white mb-5 relative z-10" data-id="element-61">
                Tenés el sistema completo de pádel
              </h3>
              <ul className="space-y-4 relative z-10" data-id="element-62">
                {conPack.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-white text-sm font-medium" data-id="element-63">
                    <span className="bg-neon/20 rounded-full p-0.5 flex-shrink-0 mt-0.5" data-id="element-64">
                      <Check className="w-4 h-4 text-neon" data-id="element-65" />
                    </span>
                    <span data-id="element-66">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}